import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { map, Observable } from 'rxjs';

import { CmsContent, CMSelectionRules } from '@fcom/core-api';
import { FragmentService } from '@fcom/common';

import { HelpButtonStatus } from '../../interfaces';

@Component({
  selector: 'fin-pre-chat',
  templateUrl: 'pre-chat.component.html',
  styleUrls: ['pre-chat.component.scss'],
})
export class PreChatComponent implements OnInit {
  readonly chatExpandKey = 'chat-expand';
  readonly HelpButtonStatus = HelpButtonStatus;

  @Output()
  chatToggle: EventEmitter<HelpButtonStatus> = new EventEmitter();

  @Output()
  startChat: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('minimize', { static: false })
  minimizeButton: ElementRef;

  availableAccordions$: Observable<CmsContent[]>;

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    this.availableAccordions$ = this.fragmentService
      .getFragment<CMSelectionRules>('fragments.chatPreScreen.url')
      .pipe(map((collection) => collection.items));
    setTimeout(() => {
      this.minimizeButton.nativeElement.focus();
    }, 0);
  }
}
